// exportVoucherTypeToExcel.ts
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'

export interface VoucherTypeExportRow {
    voucherTypeName: string
    voucherTypeNameEn: string
    status: string
    updatedBy: string
    updatedAt: string   // ISO or “YYYY-MM-DDTHH:mm:ss”
}

export interface VoucherTypeExportReport {
    title: string    // e.g. "รายการประเภทโปรโมชัน"
    statusFilter: string    // e.g. "ทั้งหมด"
    rows: VoucherTypeExportRow[],
    t: any
}

export async function exportVoucherTypeToExcel(rpt: VoucherTypeExportReport) {
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(rpt.title)
    ws.properties.defaultRowHeight = 18

    // 1) กำหนดคอลัมน์ A–F
    ws.columns = [
        { header: '#', width: 6 },
        { header: rpt.t('VOUCHER_TYPE.TABLE.VOUCHER_TYPENAME'), width: 30 },
        { header: rpt.t('VOUCHER_TYPE.TABLE.VOUCHER_TYPENAMEEN'), width: 30 },
        { header: rpt.t('VOUCHER_TYPE.TABLE.VOUCHER_STATUS'), width: 15 },
        { header: rpt.t('VOUCHER_TYPE.TABLE.UPDATED_BY'), width: 25 },
    ] as ExcelJS.Column[]

    let r = 1

    // 2) Title row (A1–E1)
    ws.mergeCells(r, 1, r, ws.columns.length)
    ws.getCell(r, 1).value = rpt.title
    ws.getCell(r, 1).font = { size: 16, bold: true }
    ws.getCell(r, 1).alignment = { horizontal: 'center', vertical: 'middle' }
    r++

    // 3) Filter row (A2–E2)
    ws.mergeCells(r, 1, r, ws.columns.length)
    ws.getCell(r, 1).value = `สถานะ: ${rpt.statusFilter}`
    ws.getCell(r, 1).font = { size: 12 }
    ws.getCell(r, 1).alignment = { horizontal: 'left', vertical: 'middle' }
    r += 2

    // 4) Header row
    const header = ws.addRow(ws.columns.map(c => c.header as string))
    header.font = { bold: true }
    header.alignment = { horizontal: 'center', vertical: 'middle' }
    header.height = 20
    header.eachCell(cell => {
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })
    r++


    if (!rpt.rows || rpt.rows.length === 0) {
        const noDataRow = ws.addRow([rpt.t('REPORT.TITLE.NO_DATA')])
        ws.mergeCells(noDataRow.number, 1, noDataRow.number, ws.columns.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
        const buf = await wb.xlsx.writeBuffer()
        saveAs(
            new Blob([buf]),
            `${rpt.title}_${moment().format('YYYYMMDD')}.xlsx`
        )
        return
    }
    // 5) Data rows
    rpt.rows.forEach((d, i) => {
        const row = ws.addRow([
            i + 1,
            d.voucherTypeName,
            d.voucherTypeNameEn,
            d.status,
            `${d.updatedBy} ${d.updatedAt}`
        ])
        row.alignment = { vertical: 'middle' }
        row.eachCell((cell, col) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            switch (col) {
                case 2:
                case 3:
                    cell.alignment = { horizontal: 'left', vertical: 'middle' }
                    break
                default:
                    cell.alignment = { horizontal: 'center', vertical: 'middle' }
            }
        })
    })

    // 6) Save file
    const buf = await wb.xlsx.writeBuffer()
    saveAs(
        new Blob([buf]),
        `${rpt.title}_${moment().format('YYYYMMDD')}.xlsx`
    )
}
